/**
 * Insights scorecard types. The shapes come from the generated
 * `@bmai/insights-api-client` (produced from the insights-api OpenAPI spec), so
 * the page renders exactly what the service returns. `FLUENCY_AXES` is a local
 * value (the client exports types only).
 */
export type {
    ScorecardSnapshot,
    ScorecardPeriod,
    ScorecardView,
    ActivityPulse,
    HeatmapDay,
    ModelMixSeries,
    ModelMixPoint,
    ExecutiveScorecard,
    AdoptionBreakdown,
    FluencyAxisScore,
    PeerStanding,
    CohortStanding,
    CohortKind,
    WinEngine,
    WinHighlight,
    BehavioralFriction,
    FrictionSession,
    EfficiencyImpact,
    EfficiencyComparison,
    WastedTokenPoint,
    UseCaseExpansion,
    UseCaseCard,
    DevelopmentPlan,
    PlanAssignment,
    TeamOverview,
    TeamMemberStanding,
    AvailableRanges,
    RangePreset,
    SavedRange,
} from '@bmai/insights-api-client';

export const FLUENCY_AXES = ['Efficiency', 'Adoption', 'Cost', 'Usage', 'Compliance'] as const;
